<template>
  <div class="score-dropdown-wrapper">
    <b-form-group :label="label" :label-for="fieldId">
      <div class="d-flex align-items-center">
        <v-select
          :id="fieldId"
          :value="value"
          :options="scoreOptions"
          :reduce="option => option.value"
          :disabled="disabled"
          :placeholder="placeholder"
          class="flex-grow-1"
          @input="handleChange"
        >
          <template #option="{ label: optionLabel }">
            {{ optionLabel }}
          </template>
        </v-select>

        <!-- Rubric tooltip icon -->
        <feather-icon
          v-if="rubric"
          v-b-popover.hover.right.html="popoverContent"
          icon="HelpCircleIcon"
          size="20"
          class="ml-2 cursor-pointer text-primary"
        />
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import vSelect from 'vue-select'

export default {
  name: 'ScoreDropdown',
  components: {
    vSelect,
  },
  props: {
    value: {
      type: [Number, String, null],
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    fieldId: {
      type: String,
      required: true,
    },
    rubric: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Seleccione score',
    },
  },
  setup(props, { emit }) {
    const scoreOptions = computed(() => {
      const options = [
        { label: '1 - Muy Bajo', value: 1 },
        { label: '2 - Bajo', value: 2 },
        { label: '3 - Medio', value: 3 },
        { label: '4 - Alto', value: 4 },
        { label: '5 - Muy Alto', value: 5 },
      ]

      // Check if rubric has an NA option in its levels
      const hasNAOption = props.rubric?.levels?.some(level => level.score === 'NA')

      if (hasNAOption) {
        options.push({ label: 'N/A - No Aplica', value: 'NA' })
      }

      return options
    })

    const popoverContent = computed(() => {
      if (!props.rubric) return ''

      let content = `<div class="rubric-popover"><strong>${props.rubric.factor}</strong><br/><br/>`

      if (props.rubric.levels && Array.isArray(props.rubric.levels)) {
        props.rubric.levels.forEach(level => {
          content += `<strong>${level.score}:</strong> ${level.description}<br/>`
        })
      }

      content += '</div>'
      return content
    })

    const handleChange = value => {
      emit('input', value)
      emit('change', value)
    }

    return {
      scoreOptions,
      popoverContent,
      handleChange,
    }
  },
}
</script>

<style scoped>
.score-dropdown-wrapper {
  margin-bottom: 1rem;
}

.cursor-pointer {
  cursor: pointer;
}
</style>

<style>
.rubric-popover {
  max-width: 400px;
  font-size: 0.875rem;
  line-height: 1.5;
}
</style>
